<template>
  <div id="products" class="animated fadeIn pb4">
    <!-- desktop view -->
    <div>
      <WebshopHeader>
      </WebshopHeader>
      <div class="clearfix" v-if="loading">
        <div class="col-12">
          <div class="loader"></div>
        </div>
      </div>
      <div class="py4 px3" v-else>
        <div class="pt2"></div>
        <!--<h4 class="darkblue bold">Dine ordrer</h4>-->
        <div class="py3">
          <div class="p0">
            <div class="el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition" v-if="orderMsg == ''">
              <div class="right-align">
                <el-pagination
                  small
                  layout="prev, pager, next"
                  :total="parseInt(lastPage)" @current-change="paginationChanged" :current-page="parseInt(curPage)">
                </el-pagination>
              </div>
              <div class="clearfix" v-if="insideLoading">
                <div class="col-12">
                  <div class="loader"></div>
                </div>
              </div>
              <div v-else>
                <table class="el-table__body col-10 p0">
                  <thead class="has-gutter">
                    <tr>
                      <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf">Status</th>
                      <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf">Ordre nummer</th>
                      <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf " style="text-align:right" >Ordre dato</th>
                      <th colspan="1" rowspan="1" style="text-align:right;"  class="el-table_1_column_1 is-leaf" >Ordre i alt</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="el-table__row" v-for="(order,index) in placeOrderData" :key="index">
                      <td class="el-table_1_column_1">
                        <a :href="'#/webshop/order?id='+order.ID" class="mintgreen bold">
                          <span v-if="order.STAGE_ID == 'EXECUTING'">Igang</span>
                          <span v-else>Betalt</span>
                        </a>
                      </td>
                      <td class="el-table_1_column_1">
                        <a :href="'#/webshop/order?id='+order.ID" class="mintgreen bold"><span>{{order.ID}}</span></a>
                      </td>
                      <td style="text-align:right;" class="el-table_1_column_1 price">
                        <a :href="'#/webshop/order?id='+order.ID" class="mintgreen bold"><span>{{order.DATE_UPDATE}}</span></a>
                      </td>
                      <td style="text-align:right;" class=" el-table_1_column_1 ">
                        <span class="bold">{{order.PRICE.slice(0, -2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' kr'}}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="mt3"><span class="bold">{{orderMsg}}</span></div>
          </div>
        </div>
        <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
      </div>
      <WebshopFooter v-if="!loading">
      </WebshopFooter>
    </div>
  </div>
</template>

<script>
import WebshopHeader from './header'
import WebshopFooter from './footer'
import Simplert from 'vue2-simplert'
export default {
  name: '',
  components: {
    WebshopHeader,
    WebshopFooter,
    Simplert
  },
  data () {
    return {
      loading: true,
      insideLoading: true,
      salesPerson: '',
      haaId: '',
      placeOrderData: [],
      orderMsg: 'Ingen Ordre.',
      curPage: 1,
      lastPage: 10
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    this.checkPlaceOrder()
    this.displayOrder()
  },
  methods: {
    showBreadCrumb () {
      document.querySelector('.breadCrumb').classList.remove('hide')
    },
    checkPlaceOrder () {
      setTimeout(() => {
        var placeOrder = sessionStorage.getItem('placeOrder')
        if (placeOrder) {
          let obj = {
            title: 'Tak for din bestilling! Du kan se status på din ordre herunder.',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          }
          this.$refs.simplert.openSimplert(obj)
          sessionStorage.removeItem('placeOrder')
        }
      }, 1500)
    },
    displayOrder () {
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetOrders/' + this.haaId + '/0?page=' + this.curPage
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var dataRes = response.data.data.data
            var pagLastPage = response.data.data.last_page + '0'
            this.placeOrderData = dataRes
            this.lastPage = pagLastPage
            if (!dataRes.length) {
              this.orderMsg = 'Ingen Ordre.'
            } else {
              this.orderMsg = ''
            }
            this.showBreadCrumb()
            this.loading = false
            this.insideLoading = false
          } else {
            this.showBreadCrumb()
            this.loading = false
            this.insideLoading = false
            console.log('Error in displayOrder()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    paginationChanged (val) {
      var pagCurPage = (`${val}`)
      this.curPage = pagCurPage
      this.displayOrder()
      this.insideLoading = true
    }
  }
}
</script>

<style>
  div .el-table td, .el-table th {
    width: 25%;
    padding: 1rem;
  }
</style>


// WEBPACK FOOTER //
// orders.vue?5d902e52